import Vue from "vue";
import {
  Button,
  Stepper,
  Search,
  Swipe,
  SwipeItem,
  Lazyload,
  Icon,
  Tag,
  List,
  Cell,
  DropdownMenu,
  DropdownItem,
  Empty,
  Toast,
  Tabbar,
  TabbarItem,
  Col,
  Row,
  Grid,
  GridItem,
  Form,
  Field,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Sku,
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  SwipeCell,
  Slider,
  Image as VanImage,
  Divider,
  Overlay,
  Loading,
  Uploader,
  Calendar,
  Tab,
  Tabs,
  NavBar,
  Sidebar,
  SidebarItem,
  Badge,
  Popup,
  Picker,
  DatetimePicker,
  PullRefresh,
} from "vant";
// import 'vant/lib/button/style';
// import 'vant/lib/stepper/style';

Vue.use(Button);
Vue.use(SwipeCell);
Vue.use(SubmitBar);
Vue.use(Card);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Sku);
Vue.use(GoodsAction);
Vue.use(GoodsActionIcon);
Vue.use(GoodsActionButton);
Vue.use(Field);
Vue.use(Form);
Vue.use(Stepper);
Vue.use(Search);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Icon);
Vue.use(Tag);
Vue.use(List);
Vue.use(Cell);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Empty);
Vue.use(Toast);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Slider);
Vue.use(VanImage);
Vue.use(Divider);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Uploader);
Vue.use(Calendar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Badge);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(PullRefresh);
